import { extendTheme } from '@chakra-ui/react';

import styles from './styles';
import components from './components';
import colors from './colors';
import breakpoints from './breakpoints';
import textStyles from './textStyles';

const theme = extendTheme({
  breakpoints,
  styles: {
    ...styles,
  },
  textStyles,
  colors: {
    ...colors,
  },
  components: {
    ...components,
  },
});

export default theme;
